<template>
    <v-card class="elevation-0">
        <!--Filter box-->
        <v-layout align-center wrap style="padding: 24px 20px 0 20px; margin-bottom: 12px">
            <v-spacer></v-spacer>
            <div class="btn-custom mr-8" @click="openTestInboundDialog" v-if="showCallTestInbound">
                {{ $f.tc('testCallInbound') }}
            </div>
            <div style="width: 180px; margin-right: 8px">
                <v-select
                    :label="$f.tc('refresh')"
                    v-model="autoRefreshInterval"
                    :items="autoRefreshIntervalList"
                    hide-details outlined
                    class="input-custom"
                ></v-select>
            </div>
            <TimeRangePicker ref="TimeRangePicker" v-model="timeRange"></TimeRangePicker>
            <div
                class="ml-8"
                :class="isLoadingRefresh ? 'btn-disable' : 'btn-custom'"
                @click="refresh"
            >
                <v-progress-circular
                    indeterminate
                    width="3"
                    color="grey"
                    class="mr-6"
                    style="width: 16px"
                    v-if="isLoadingRefresh"
                ></v-progress-circular>
                <v-icon v-else style="margin-right: 6px; color: #FFFFFF; width: 16px">mdi-filter-outline</v-icon>
                {{ $f.tc('filter') }} / {{ $f.tc('refresh') }}
            </div>
        </v-layout>
        <!--List charts-->
        <template v-if="overviewData">
            <v-layout row wrap style="padding: 0 16px">
                <!--Chart customer-->
                <v-flex xs12 md4 v-if="campaign.direction === 'OUTBOUND' && dataChartCustomerOutbound">
                    <DoughNutChartCustom
                        :data="dataChartCustomerOutbound"
                        :show-table="true"
                        chart-title="title empty"
                        additional-header="subTitle empty"
                        :unit="'customers'"
                        ref="chart0"/>
                </v-flex>
                <!--Chart most dialed phone numbers-->
                <v-flex xs12 md4 v-else style="position: relative">
                    <div class="card-chart">
                        <div class="title-chart" style="margin: 20px 0 0 10px">{{ 'Most Dialed Phone Numbers' }}</div>
                        <div v-if="dataChartCustomerInbound.labels.length!==0">
                            <HorizontalBarChart v-if="dataChartCustomerInbound.labels.length>=5"
                                                :data="dataChartCustomerInbound"
                                                :title-left="''"
                                                :y-axis-ticks="true"
                                                :height="210"
                                                ref="HorizontalChartCallByTime"
                            ></HorizontalBarChart>
                            <CampaignStackBarChart v-else
                                                   :data="dataChartCustomerInbound"
                                                   :title-left="''"
                                                   :y-axis-ticks="true"
                                                   ref="HorizontalChartCallByTime"
                                                   :display-legend="false"
                                                   :height="210"
                            ></CampaignStackBarChart>
                            <div style="width: 80px;" class="select-option-limit">
                                <v-select
                                    hide-details
                                    color="#0052CC"
                                    v-model="sizeMostPhone"
                                    :items="listSizeMostPhone"
                                    @input="updateSizeMostPhone"
                                    class="input-custom"
                                ></v-select>
                            </div>
                            <div class="btn-icon btn-info-chart">
                                <v-icon color="#96ADD0">mdi-information</v-icon>
                            </div>
                            <div class="info-chart">
                                <table class="additional-data">
                                    <tbody>
                                    <tr v-for="(item, index) in avgCallPerCustomer" :key="index">
                                        <td>{{ $f.tc(`${index}`) }}</td>
                                        <td><b>{{ item }}</b></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div v-else style="text-align: center; margin-top: 20px">
                            <img src="/img/bar-chart-1.png" alt="bar-chart"
                                 style="max-height: 190px; margin-bottom: 16px">
                            <div style="margin-bottom: 20px; font-size: 14px ; color: #96ADD0">
                                {{ $f.tc('noDataAvailable') }}
                            </div>
                        </div>
                    </div>
                </v-flex>
                <!--Chart total call-->
                <v-flex xs12 md4>
                    <div v-if="overviewData[0]" style="height: 100%">
                        <DoughNutChartCustom
                            :data="overviewData[0] ? overviewData[0]['data'] : []"
                            :show-table="true"
                            chart-title="title empty"
                            additional-header="subTitle empty"
                            class="dough-nut-chart-wrap-custom"
                            :unit="'calls'"
                            ref="chart1"/>
                    </div>
                </v-flex>
                <!--Chart connected call-->
                <v-flex xs12 md4>
                    <div v-if="dataConnectedCall[0]" style="position: relative; height: 100%">
                        <DoughNutChartCustom
                            :data="dataConnectedCall[0] ? dataConnectedCall[0]['data'] : []"
                            :show-table="true"
                            chart-title="title empty"
                            additional-header="subTitle empty"
                            class="dough-nut-chart-wrap-custom"
                            :unit="'calls'"
                            ref="chart2"/>
                        <div style="width: 150px; position: absolute; top: 27px; right: 70px;">
                            <v-select
                                hide-details
                                color="#0052CC"
                                v-model="filterConnectedCall"
                                :items="listFilterConnectedCall"
                                item-text="value"
                                item-value="key"
                                class="input-custom"
                                style="margin-right: 0 !important;"
                                @input="updateFilterConnectedCall"
                            ></v-select>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
            <div style="margin-top: 8px; padding: 0 16px 16px 16px">
                <v-layout row wrap>
                    <!--Chart number of calls by time-->
                    <v-flex xs12 md6>
                        <div class="card-chart">
                            <v-layout align-center justify-space-between style="padding: 12px 20px 20px 20px">
                                <div class="title-chart">{{ $f.tc('numberOfCallsByTime') }}</div>
                                <div style="width: 150px">
                                    <v-select
                                        hide-details
                                        color="#0052CC"
                                        v-model="interval"
                                        :items="listOptionTimes"
                                        item-text="name"
                                        item-value="key"
                                        class="input-custom"
                                        style="margin-right: 0 !important;"
                                        @input="updateInterval"
                                    ></v-select>
                                </div>
                            </v-layout>
                            <div v-if="callByTimeChart.total > 0">
                                <stack-bar-chart
                                    :data="callByTimeChart"
                                    :title-left="''"
                                    :y-axis-ticks="true"
                                    ref="StackBarChartCallByTime"
                                ></stack-bar-chart>
                            </div>
                            <div v-else style="text-align: center; margin-top: 20px">
                                <img src="/img/bar-chart-1.png" alt="bar-chart"
                                     style="height: 280px; margin-bottom: 16px">
                                <div style="margin-bottom: 20px; font-size: 14px ; color: #96ADD0">
                                    {{ $f.tc('noDataAvailable') }}
                                </div>
                            </div>
                        </div>
                    </v-flex>
                    <!--Chart number of calls by call duration-->
                    <v-flex xs12 md6 style="position: relative">
                        <div class="card-chart">
                            <div style="padding: 12px 10px 20px">
                                <div class="title-chart">{{ $f.tc('callDuration') }}</div>
                            </div>
                            <div v-if="callDurationChart.total > 0">
                                <stack-bar-chart
                                    :data="callDurationChart"
                                    :title-left="''"
                                    :y-axis-ticks="true"
                                    ref="StackBarChartCallDuration"
                                ></stack-bar-chart>
                                <div class="btn-icon btn-info-chart">
                                    <v-icon color="#96ADD0">mdi-information</v-icon>
                                </div>
                                <div class="info-chart">
                                    <table class="additional-data">
                                        <tbody>
                                        <tr v-for="(item, index) in avgDurationPerCall" :key="index">
                                            <td>{{ $f.tc(`${index}`) }}</td>
                                            <td><b>{{ item }}</b></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else style="text-align: center; margin-top: 20px">
                                <img src="/img/bar-chart-2.png" alt="bar-chart"
                                     style="height: 280px; margin-bottom: 16px">
                                <div style="margin-bottom: 20px; font-size: 14px; color: #96ADD0">
                                    {{ $f.tc('noDataAvailable') }}
                                </div>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </div>
        </template>
        <div v-else style="display: flex; align-items: center; justify-content: center; height: 200px">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
            <div style="margin-left: 8px; font-size: 14px">{{ $f.tc('loadingData') }}</div>
        </div>
    </v-card>
</template>

<script>
import DoughNutChartCustom from "@/components/chart/DoughNutChartCustom";
import CampaignService from '@/services/campaign.service'
import AutoRefreshMixin from '@/modules/fptai/mixins/AutoRefreshMixin'
import TimeRangePicker from '@/modules/fptai/components/TimeRangePicker'
import StackBarChart from "@/components/chart/StackBarChart";
import HorizontalBarChart from "@/views/Campaign/CampaignHorizontalBarChart";
import CampaignStackBarChart from "@/views/Campaign/CampaignStackBarChart";
import {thisGroup} from "@/modules/fptai/components/TimeRangePickerQuickOptions";
import $const from "@/utils/const";

const defaultFilter = {
    filterConnectedCall: 'ending_by',
    timeRange: 'today',
    sizeMostPhone: 10
}

const showTimeRangeTypes = $const.ShowTimeRangeTypes

export default {
    name: 'CampaignDetailsOverview',
    components: {
        TimeRangePicker,
        DoughNutChartCustom,
        StackBarChart,
        HorizontalBarChart,
        CampaignStackBarChart,
    },
    mixins: [AutoRefreshMixin],
    props: {
        campaign: Object
    },
    data() {
        return {
            overviewData: [],
            timeRange: this.$utils.cloneObject(defaultFilter.timeRange),
            isLoadingRefresh: false,
            dataConnectedCall: [],
            dataChartCustomerOutbound: null,
            callDurationChart: {
                datasets: [],
                labels: [],
                tooltip: [],
                total: 0,
                maxCountChart: 0
            },
            callByTimeChart: {
                datasets: [],
                labels: [],
                tooltip: [],
                total: 0,
                maxCountChart: 0
            },
            dataChartCustomerInbound: {
                datasets: [],
                labels: [],
                tooltip: [],
                total: 0
            },
            avgCallPerCustomer: {
                totalCalls: '',
                totalCustomers: '',
                avg: ''
            },
            avgDurationPerCall: {
                totalCalls: '',
                totalDuration: '',
                avg: ''
            },
            interval: '',
            formatDateTime: '',
            filterConnectedCall: this.$utils.cloneObject(defaultFilter.filterConnectedCall),
            listFilterConnectedCall: [
                {
                    key: 'ending_by',
                    value: this.$f.tc('endingBy'),
                },
                {
                    key: 'action_code',
                    value: this.$f.tc('actionCodes'),
                },
            ],
            listOptionTimes: [],
            sizeMostPhone: this.$utils.cloneObject(defaultFilter.sizeMostPhone),
            listSizeMostPhone: [5, 10, 15, 20],
            showCallTestInbound: false
        }
    },
    computed: {
        listFilter() {
            return [
                {
                    name: '1 ' + this.$f.tc('minute'),
                    value: 60000,
                    key: '1m',
                },
                {
                    name: '3 ' + this.$f.tc('minute'),
                    value: 3 * 60000,
                    key: '3m',
                },
                {
                    name: '5 ' + this.$f.tc('minute'),
                    value: 5 * 60000,
                    key: '5m',
                },
                {
                    name: '10 ' + this.$f.tc('minute'),
                    value: 10 * 60000,
                    key: '10m',
                },
                {
                    name: '30 ' + this.$f.tc('minute'),
                    value: 30 * 60000,
                    key: '30m',
                },
                {
                    name: '1 ' + this.$f.tc('hour'),
                    value: 60 * 60000,
                    key: '1h',
                },
                {
                    name: '2 ' + this.$f.tc('hour'),
                    value: 2 * 60 * 60000,
                    key: '2h',
                },
                {
                    name: '4 ' + this.$f.tc('hour'),
                    value: 4 * 60 * 60000,
                    key: '4h',
                },
                {
                    name: '8 ' + this.$f.tc('hour'),
                    value: 8 * 60 * 60000,
                    key: '8h',
                },
                {
                    name: '1 ' + this.$f.tc('day'),
                    value: 24 * 60 * 60000,
                    key: '1d',
                },
                {
                    name: '2 ' + this.$f.tc('day'),
                    value: 2 * 24 * 60 * 60000,
                    key: '2d',
                },
                {
                    name: '5 ' + this.$f.tc('day'),
                    value: 5 * 24 * 60 * 60000,
                    key: '5d',
                },
                {
                    name: '10 ' + this.$f.tc('day'),
                    value: 10 * 24 * 60 * 60000,
                    key: '10d',
                },
                {
                    name: '1 ' + this.$f.tc('month'),
                    value: 30 * 24 * 60 * 60000,
                    key: '1M',
                },
            ]
        }
    },
    mounted() {
        this.beforeRefresh()
        this.getCallTestInboundConfig()
    },
    methods: {
        clearLocalStorage() {
            localStorage.removeItem("service_number")
            localStorage.removeItem("target")
            localStorage.removeItem("web_socket_server")
        },
        beforeRefresh() {
            let query = this.$utils.cloneObject(this.$route.query)

            // validate filter_connected_call
            if (query['filter_connected_call'] && this.listFilterConnectedCall.find(i => i.key === query['filter_connected_call'])) {
                this.filterConnectedCall = query['filter_connected_call']
            } else {
                delete query['filter_connected_call']
            }

            // validate size_most_phone
            let sizeMostPhone = parseInt(query['size_most_phone']) || null
            if (sizeMostPhone && this.listSizeMostPhone.includes(sizeMostPhone)) {
                this.sizeMostPhone = sizeMostPhone
            } else {
                delete query['size_most_phone']
            }

            if (!query['time_range'] || (query['time_range'] && query['time_range'] === defaultFilter.timeRange)) {
                this.updateDataCharts(query.interval)
            } else {
                this.updateTimeRangeFilter()
            }

            this.$router.replace({
                query: query
            })
        },
        updateTimeRangeFilter() {
            let query = this.$utils.cloneObject(this.$route.query)
            // validate time_range
            if (query['time_range']) {
                if (thisGroup.find(i => i.value === query['time_range'])) { // case quick option
                    this.timeRange = query['time_range']
                } else { // case custom
                    let timeRangeSplit = query['time_range'].split("to")
                    let from = parseInt(timeRangeSplit[0]) || null
                    let to = parseInt(timeRangeSplit[1]) || null
                    if (from && to && to > from) {
                        let format = 'YYYY-MM-DD HH:mm'
                        let fromTime = this.$utils.convertTimestampToStringFormat(from, format)
                        let toTime = this.$utils.convertTimestampToStringFormat(to, format)
                        this.$refs.TimeRangePicker.updateTypeShow(showTimeRangeTypes.CUSTOM)
                        this.$refs.TimeRangePicker.updateFromToCustom(`${fromTime} ➜ ${toTime}`)
                        this.timeRange = `${fromTime} ➜ ${toTime}`
                    } else {
                        delete query['time_range']
                    }
                }
            } else {
                delete query['time_range']
            }
        },
        updateDataCharts(key) {
            this.listOptionTimes = this.updateOptionTimes()
            if (key && this.listOptionTimes.find(i => i.key === key)) {
                this.interval = key
            } else {
                this.interval = this.listOptionTimes[0].key
                let query = this.$utils.cloneObject(this.$route.query)
                delete query.interval
                this.$router.replace({
                    query: query
                })
            }
            this.updateInterval(false)
            this.refresh()
        },
        updateOptionTimes() {
            let optionTimes = []
            let timeRange = this.$refs.TimeRangePicker.getTimeRangeInDjango()
            let timeTo
            if (Date.parse(timeRange.to) > Date.now()) {
                timeTo = Date.now()
            } else timeTo = Date.parse(timeRange.to)
            let duration_filter = timeTo - Date.parse(timeRange.from)
            // check timeRange trong khoảng cho phép
            for (let f = 0; f < this.listFilter.length; f++) {
                if (Math.floor(duration_filter / 30) < parseInt(this.listFilter[f].value) && parseInt(this.listFilter[f].value) < Math.floor(duration_filter / 5)) {
                    optionTimes.push(this.listFilter[f])
                }
            }
            if (Math.floor(duration_filter / 30) <= parseInt(this.listFilter[0].value)) {
                optionTimes.push(this.listFilter[0])
            }
            if (Math.floor(duration_filter / 5) >= parseInt(this.listFilter.slice(-1)[0].value)) {
                optionTimes.push(this.listFilter.slice(-1)[0])
            }
            return optionTimes
        },
        updateInterval(isLoadData) {
            this.updateQueryRoute('interval', this.interval, this.listOptionTimes[0].key)
            if (isLoadData) {
                this.loadCallByTimeChartData()
            }
            this.mapIntervalFormat()
        },
        refresh() {
            if (this.isLoadingRefresh) {
                return
            }
            if (!this.campaign) {
                return
            }
            this.mapIntervalFormat()
            this.getDataChart()
        },
        mapIntervalFormat() {
            let lastChar = this.interval.substring(this.interval.length - 1)
            switch (lastChar) {
                case 'M':
                    this.formatDateTime = 'MM-YYYY'
                    break
                case 'd':
                    this.formatDateTime = 'DD-MM-YYYY'
                    break
                default:
                    this.formatDateTime = 'HH:mm DD-MM-YYYY'
                    break
            }
        },
        getDataChart() {
            this.isLoadingRefresh = true
            Promise.all([
                this.getDataPieCharts(),
                this.getDataPieChartConnectedCall(),
                this.getDataChartCustomer(),
                this.getDataStackBarCharts()
            ])
                .catch(this.stopInterval)
                .finally(() => {
                    this.isLoadingRefresh = false
                })
        },
        getDataPieCharts() {
            let timeRange = this.$refs.TimeRangePicker.getTimestamp()
            return CampaignService.getCampaignsOverview(this.campaign.id, timeRange.from, timeRange.to).then(
                result => this.overviewData = result,
                this.$appService.handleRequestError('Can not load Overview data')
            )
        },
        getDataPieChartConnectedCall() {
            let timeRange = this.$refs.TimeRangePicker.getTimestamp()
            return CampaignService.getPieChartConnectedCall(this.campaign.id, timeRange.from, timeRange.to, this.filterConnectedCall).then(
                result => this.dataConnectedCall = result,
                this.$appService.handleRequestError('Can not load data Connected Call')
            )
        },
        getDataChartCustomer() {
            let timeRange = this.$refs.TimeRangePicker.getTimestamp()
            return CampaignService.getChartCustomer(this.campaign.id, timeRange.from, timeRange.to, this.sizeMostPhone).then(
                result => {
                    if (this.campaign.direction === 'OUTBOUND') {
                        this.dataChartCustomerOutbound = result.data
                    } else {
                        if (result.data.data_chart.length > 0) {
                            this.avgCallPerCustomer = {
                                totalCalls: result.data['total_calls'],
                                totalCustomers: result.data['total_customers'],
                                avg: result.data['avg']
                            }
                            let listDataPhone = []
                            let listTooltip = []
                            this.dataChartCustomerInbound = {
                                labels: [],
                                datasets: [],
                                tooltip: [],
                                total: result.data['total_calls']
                            }
                            result.data['data_chart'].forEach(item => {
                                listDataPhone.push(item['call_count'])
                                this.dataChartCustomerInbound.labels.push(item['phone_number'])
                                listTooltip.push(
                                    [
                                        {
                                            name: this.$f.tc('phone'),
                                            value: item['phone_number']
                                        },
                                        {
                                            name: this.$f.tc('numberOfCalls'),
                                            value: item['call_count']
                                        },
                                        {
                                            name: this.$f.tc('startTime'),
                                            value: ''
                                        }
                                    ]
                                )
                            })
                            this.dataChartCustomerInbound.tooltip = listTooltip
                            this.dataChartCustomerInbound.datasets = [
                                {
                                    label: "",
                                    data: listDataPhone,
                                    backgroundColor: '#2E7CEF',
                                    data_chart: result.data.data_chart
                                }
                            ]
                        } else {
                            this.dataChartCustomerInbound = {
                                labels: [],
                                datasets: [],
                                tooltip: [],
                                total: 0
                            }
                        }
                    }
                },
                this.$appService.handleRequestError('Can not load Overview data')
            )
        },
        getDataStackBarCharts() {
            return Promise.all([
                this.loadCallByTimeChartData(),
                this.loadCallDurationChartData()
            ]).then(() => {
                    if (this.$refs.StackBarChartCallByTime) {
                        this.$refs.StackBarChartCallByTime.render()
                    }
                    if (this.$refs.StackBarChartCallDuration) {
                        this.$refs.StackBarChartCallDuration.render()
                    }
                }
            )
        },
        loadCallByTimeChartData() {
            if (!this.interval) {
                return
            }
            return new Promise((resolve, reject) => {
                let timeStamp = this.$refs.TimeRangePicker.getTimestamp()
                CampaignService.statCallsByTime(
                    this.campaign.id,
                    {
                        from: timeStamp.from,
                        to: timeStamp.to
                    },
                    this.interval
                ).then(result => {
                    if (result.data) {
                        let listDataConnected = []
                        let listDataUnconnected = []
                        let listDataInBlackList = []
                        let listTooltip = []
                        this.callByTimeChart = {
                            labels: [],
                            datasets: [],
                            tooltip: [],
                            total: result.data['total_calls'],
                            maxCountChart: result.data['max_count_chart']
                        }
                        result.data.data_chart.forEach((item, index) => {
                            listDataConnected.push(item['connected']['total_calls'])
                            listDataUnconnected.push(item['unconnected']['total_calls'])
                            listDataInBlackList.push(item['in_black_list']['total_calls'])
                            this.callByTimeChart.labels.push(this.$utils.convertTimestampToStringFormat(item['date_time'], this.formatDateTime))
                            let endTime
                            if (index + 1 >= result.data.data_chart.length) {
                                switch (timeStamp.to < Date.now()) {
                                    case true:
                                        endTime = timeStamp.to / 1000
                                        break
                                    case false:
                                        endTime = Date.now() / 1000
                                        break
                                }
                            } else {
                                endTime = result.data.data_chart[index + 1]['date_time']
                            }
                            listTooltip.push(
                                [
                                    {
                                        name: 'Start time',
                                        value: this.$utils.convertTimestampToStringFormat(item['date_time'], this.formatDateTime)
                                    },
                                    {
                                        name: 'End time',
                                        value: this.$utils.convertTimestampToStringFormat(endTime, this.formatDateTime)
                                    },
                                    {
                                        name: 'Total calls',
                                        value: `${item['total_calls']} (${item['total_calls'] / item['total_calls'] * 100}%)`
                                    },
                                    {
                                        name: 'Connected',
                                        value: `${item['connected']['total_calls']} (${Math.round(item['connected']['total_calls'] / item['total_calls'] * 10000) / 100}%)`
                                    },
                                    {
                                        name: 'In Black List',
                                        value: `${item['in_black_list']['total_calls']} (${Math.round(item['in_black_list']['total_calls'] / item['total_calls'] * 10000) / 100}%)`
                                    },
                                    {
                                        name: 'Unconnected',
                                        value: `${item['unconnected']['total_calls']} (${Math.round(item['unconnected']['total_calls'] / item['total_calls'] * 10000) / 100}%)`
                                    }
                                ]
                            )
                        })
                        this.callByTimeChart.tooltip = listTooltip
                        this.callByTimeChart.datasets = [
                            {
                                label: "Connected",
                                data: listDataConnected,
                                backgroundColor: '#2BC685',
                                data_chart: result.data.data_chart
                            },
                            {
                                label: 'Unconnected',
                                data: listDataUnconnected,
                                backgroundColor: '#FA7402',
                                data_chart: result.data.data_chart
                            },
                            {
                                label: 'In Black List',
                                data: listDataInBlackList,
                                backgroundColor: '#626475',
                                data_chart: result.data.data_chart
                            }
                        ]
                    } else {
                        this.callByTimeChart = {
                            labels: [],
                            datasets: [],
                            tooltip: [],
                            total: 0,
                            maxCountChart: 0
                        }
                    }
                    resolve()
                }, error => {
                    this.$appService.hideLoading()
                    reject(error)
                })
            })
        },
        loadCallDurationChartData() {
            return new Promise((resolve, reject) => {
                let timeStamp = this.$refs.TimeRangePicker.getTimestamp()
                CampaignService.statCallsByCallDuration(
                    this.campaign.id,
                    {
                        from: timeStamp.from,
                        to: timeStamp.to
                    }
                ).then(result => {
                    if (result.data) {
                        let listDataDropByCustomer = []
                        let listDataDropByBOT = []
                        let listDataCallTransfer = []
                        let listTooltip = []
                        this.callDurationChart = {
                            labels: [],
                            datasets: [],
                            tooltip: [],
                            total: result.data['total_calls'],
                            maxCountChart: result.data['max_count_chart']
                        }
                        this.avgDurationPerCall = {
                            totalCalls: result.data['total_calls'],
                            totalDuration: this.$filters.toHMS(result.data['talk_time_calls']),
                            avg: this.$filters.toHMS((Number(result.data['talk_time_calls']) / Number(result.data['total_calls'])).toFixed(3))
                        }
                        result.data.data_chart.forEach(item => {
                            listTooltip.push(
                                [
                                    {
                                        name: 'Durations',
                                        value: item['from_to']
                                    },
                                    {
                                        name: 'Total calls',
                                        value: item['count_call']
                                    },
                                    {
                                        name: 'Drop by bot',
                                        value: item['drop_by_bot']
                                    },
                                    {
                                        name: 'Drop by customer',
                                        value: item['drop_by_customer']
                                    },
                                    {
                                        name: 'Call transfer',
                                        value: item['call_transfer']
                                    }
                                ]
                            )
                            listDataDropByCustomer.push(item['drop_by_customer'])
                            listDataDropByBOT.push(item['drop_by_bot'])
                            listDataCallTransfer.push(item['call_transfer'])
                            this.callDurationChart.labels.push(item['from_to'])
                        })
                        this.callDurationChart.tooltip = listTooltip
                        this.callDurationChart.datasets = [
                            {
                                label: "Drop by customer",
                                data: listDataDropByCustomer,
                                backgroundColor: '#1A68FF'
                            },
                            {
                                label: 'Drop by BOT',
                                data: listDataDropByBOT,
                                backgroundColor: '#FFAC36'
                            },
                            {
                                label: 'Call transfer',
                                data: listDataCallTransfer,
                                backgroundColor: '#376240de'
                            }
                        ]
                    } else {
                        this.callDurationChart = {
                            labels: [],
                            datasets: [],
                            tooltip: [],
                            total: 0,
                            maxCountChart: 0
                        }
                    }
                    resolve()
                }, error => {
                    this.$appService.hideLoading()
                    reject(error)
                })
            })
        },
        updateSizeMostPhone(newVal) {
            this.updateQueryRoute('size_most_phone', newVal, defaultFilter.sizeMostPhone)
            this.getDataChartCustomer()
        },
        updateFilterConnectedCall(newVal) {
            this.updateQueryRoute('filter_connected_call', newVal, defaultFilter.filterConnectedCall)
            this.getDataPieChartConnectedCall()
        },
        updateQueryRoute(nameQuery, newVal, defaultVal) {
            let query = this.$utils.cloneObject(this.$route.query)
            if (newVal !== defaultVal) {
                query[nameQuery] = newVal
            } else {
                delete query[nameQuery]
            }
            this.$router.replace({
                query: query
            })
        },
        openTestInboundDialog() {
            this.$router.push('/campaign/' + this.campaign.id + '/test-call-inbound')
        },
        getCallTestInboundConfig() {
            this.clearLocalStorage()
            // neu campaign la INBOUND thi luu service_number vao local storage de call test inbound
            if (this.campaign.direction === 'INBOUND') {
                CampaignService.getCallTestInboundConfig(this.campaign.id).then(result => {
                    if (result.data['service_number'] && result.data['target'] && result.data['web_socket_server']) {
                        localStorage.setItem("service_number", result.data['service_number'])
                        localStorage.setItem("target", result.data['target']);
                        localStorage.setItem("web_socket_server", result.data['web_socket_server'])
                        this.showCallTestInbound = true
                    }
                })
            }
        }
    },
    watch: {
        timeRange: function (newVal) {
            let query = this.$utils.cloneObject(this.$route.query)
            if (newVal.includes('➜')) {
                let fromTo = newVal.split('➜')
                let from = this.$utils.convertDateStringToTimestamp(fromTo[0].trim() + ':00')
                let to = this.$utils.convertDateStringToTimestamp(fromTo[1].trim() + ':59')
                query['time_range'] = `${from}to${to}`
            } else {
                if (newVal !== defaultFilter.timeRange) {
                    query['time_range'] = newVal
                } else {
                    delete query['time_range']
                }
            }
            this.$router.replace({
                query: query
            })
            this.updateDataCharts(query.interval)
        },
        dataChartCustomerInbound: {
            deep: true,
            handler: function () {
                this.$nextTick(() => {
                    if (this.$refs.HorizontalChartCallByTime) {
                        this.$refs.HorizontalChartCallByTime.render()
                    }
                })
            }
        },
        callByTimeChart: {
            deep: true,
            handler: function () {
                this.$nextTick(() => {
                    if (this.$refs.StackBarChartCallByTime) {
                        this.$refs.StackBarChartCallByTime.render()
                    }
                })
            }
        },
        callDurationChart: {
            deep: true,
            handler: function () {
                this.$nextTick(() => {
                    if (this.$refs.StackBarChartCallDuration) {
                        this.$refs.StackBarChartCallDuration.render()
                    }
                })
            }
        }
    },
    destroyed() {
        this.$store.commit(this.$actionTypes.campaign.UPDATE_CAMPAIGN, false)
    }
}
</script>
<style lang="scss" scoped>
.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }

            .v-select__selections {
                width: 200px;
            }
        }

        .v-label {
            background: #FFFFFF !important;
            padding: 0 6px;

            &:not(.v-label--active) {
                font-size: 14px !important;
                padding-left: 0 !important;
            }
        }
    }
}

.btn-disable {
    font-family: "open sans", serif !important;
}

.btn-info-chart {
    position: absolute;
    top: 36px;
    right: 30px;


    &:hover ~ .info-chart {
        visibility: visible;
    }
}

.select-option-limit {
    position: absolute;
    top: 36px;
    right: 70px;
}

.info-chart {
    position: absolute;
    top: 65px;
    right: 35px;
    border: 1px solid #e4edfa;
    background: #fff;
    font-size: 14px;
    padding: 12px;
    border-radius: 5px;
    visibility: hidden;
}

.card-chart {
    border-radius: 5px;
    border: 1px solid #e4edfa;
    background: #FFFFFF;
    padding: 10px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ::v-deep {
        .v-text-field {
            padding-top: 0 !important;
            margin-top: 0 !important;
        }

        .v-input__slot {
            margin-bottom: 0 !important;
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }
}

.title-chart {
    line-height: 30px;
    height: 30px;
    font-size: 16px;
    font-weight: 700;
}

.additional-data {
    width: 100%;
    margin: 0;
    border-spacing: 0;


    tbody {
        td {
            font-size: 14px;
            padding: 12px;
        }

        td:last-child {
            text-align: right;
        }

        tr:nth-child(2n+2) td {
            background: #E4EDFA;
        }
    }
}
</style>
